import { Component, OnInit } from "@angular/core";
import { Ruta, RutasService } from "../../../../shared/services/ruta.service";
import {
  IdentRutaPayload,
  IdentRutasService,
} from "../../../../shared/services/ident-rutas.service";
import {
  TipoRutaPesvOption,
  TipoRutaPesvService,
} from "../../../../shared/services/tipo-rutapesv.service";
import {
  FrecuenciaRecorridoOption,
  FrecuenciaRecorridoService,
} from "../../../../shared/services/frecuencia-recorrido.service";
import { Utils } from "../../../../shared/utils/Utils";
import { catchError, map } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
const Swal = require("sweetalert2");

@Component({
  selector: "app-identificar-rutas-pesv",
  templateUrl: "./identificar_rutas.component.html",
  styleUrls: ["./identificar_rutas.component.scss"],
})
export class IdentificarRutasPesvComponent implements OnInit {
  cargando = false;
  guardandoTodo = false;
  rutas: Ruta[] = [];
  rutasFiltradas: Ruta[] = [];
  registrosIdentRuta: Record<string, any> = {};
  tiposRuta: TipoRutaPesvOption[] = [];
  frecuenciasRecorrido: FrecuenciaRecorridoOption[] = [];
  filtro = "";
  pageSize = 10;
  page = 1;
  sortColumn = "";
  sortDirection: "asc" | "desc" = "asc";

  constructor(
    private rutasService: RutasService,
    private identRutasService: IdentRutasService,
    private tipoRutaPesvService: TipoRutaPesvService,
    private frecuenciaRecorridoService: FrecuenciaRecorridoService
  ) {}

  ngOnInit(): void {
    this.cargarCatalogos();
    this.cargarRutas();
  }

  private cargarCatalogos(): void {
    forkJoin({
      tiposRuta: this.tipoRutaPesvService.getAll().pipe(catchError(() => of([]))),
      frecuencias: this.frecuenciaRecorridoService.getAll().pipe(catchError(() => of([]))),
    }).subscribe({
      next: ({ tiposRuta, frecuencias }) => {
        this.tiposRuta = this.normalizarOpcionesCatalogo(tiposRuta);
        this.frecuenciasRecorrido = this.normalizarOpcionesCatalogo(frecuencias);
      },
      error: () => {
        this.tiposRuta = [];
        this.frecuenciasRecorrido = [];
      },
    });
  }

  cargarRutas(): void {
    this.cargando = true;
    forkJoin({
      rutasBase: this.rutasService.getRutas().pipe(catchError(() => of([]))),
      identRutas: this.identRutasService.getAll().pipe(catchError(() => of([]))),
    }).subscribe({
      next: ({ rutasBase, identRutas }) => {
        this.registrosIdentRuta = this.crearIndiceIdentRutas(identRutas);
        this.rutas = this.normalizarRespuestaRutas(rutasBase).map((ruta: any) =>
          this.inicializarFila(ruta)
        );
        this.aplicarFiltro();
        this.cargando = false;
      },
      error: (error: any) => {
        console.error("Error cargando rutas para identificar_rutas:", error);
        this.rutas = [];
        this.rutasFiltradas = [];
        this.cargando = false;
      },
    });
  }

  aplicarFiltro(): void {
    const termino = String(this.filtro || "").trim().toLowerCase();
    this.page = 1;

    const filtradas = !termino
      ? [...this.rutas]
      : this.rutas.filter((ruta: any) => {
      return (
        String(ruta?.id || "").toLowerCase().includes(termino) ||
        String(ruta?.nombre_ruta || ruta?.nombre || "").toLowerCase().includes(termino) ||
        String(ruta?.ruta || "").toLowerCase().includes(termino) ||
        String(ruta?.salida || ruta?.municipioOrigen?.MUNICIPIO || ruta?.origen || "")
          .toLowerCase()
          .includes(termino) ||
        String(ruta?.destino || ruta?.municipioDestino?.MUNICIPIO || "")
          .toLowerCase()
          .includes(termino) ||
        String(ruta?.kilometros_recorridos || "").toLowerCase().includes(termino)
      );
    });

    this.rutasFiltradas = filtradas;
    if (this.sortColumn) {
      this.sortData(this.sortColumn, true);
    }
  }

  sortData(column: string, preserveDirection = false): void {
    if (this.sortColumn === column && !preserveDirection) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else if (this.sortColumn !== column) {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    const listToSort = this.rutasFiltradas.length ? this.rutasFiltradas : this.rutas;
    const direction = this.sortDirection === "asc" ? 1 : -1;

    listToSort.sort((a: any, b: any) => {
      const aVal = this.obtenerValorOrdenRuta(a, column);
      const bVal = this.obtenerValorOrdenRuta(b, column);

      if (aVal < bVal) {
        return -1 * direction;
      }

      if (aVal > bVal) {
        return 1 * direction;
      }

      return 0;
    });

    this.rutasFiltradas = [...listToSort];
  }

  private obtenerValorOrdenRuta(ruta: any, column: string): string {
    if (column === "nombre_ruta") {
      return String(ruta?.nombre_ruta || ruta?.nombre || "").trim().toLowerCase();
    }

    if (column === "origen") {
      return String(ruta?.salida || ruta?.municipioOrigen?.MUNICIPIO || ruta?.origen || "")
        .trim()
        .toLowerCase();
    }

    if (column === "destino") {
      return String(ruta?.destino || ruta?.municipioDestino?.MUNICIPIO || "")
        .trim()
        .toLowerCase();
    }

    return String(this.getNestedValue(ruta, column) || "").trim().toLowerCase();
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj) ?? "";
  }

  estadoRutaTexto(estado: any): string {
    return Number(estado) === 1 ? "ACTIVA" : "INACTIVA";
  }

  estadoRutaClase(estado: any): string {
    return Number(estado) === 1 ? "badge badge-success" : "badge badge-danger";
  }

  guardarIdentRuta(fila: any): void {
    fila.tipo_ruta = this.normalizarIdSeleccion(fila?.tipo_ruta) || this.obtenerTipoRutaPorDefecto();
    fila.frecuencia_recorrido =
      this.normalizarIdSeleccion(fila?.frecuencia_recorrido) || this.obtenerFrecuenciaPorDefecto();

    const payload = this.construirPayload(fila);
    const id = Number(fila?.id_ident_ruta || 0);
    const request$ = id
      ? this.identRutasService.update(id, payload)
      : this.identRutasService.create(payload);

    fila.guardando = true;
    request$.subscribe({
      next: (resp: any) => {
        fila.guardando = false;
        if (!id) {
          const idCreado = Number(resp?.id || resp?.ident_ruta?.id || 0);
          if (idCreado) {
            fila.id_ident_ruta = idCreado;
          }
        }

        fila._ident = {
          ...(fila?._ident || {}),
          ...payload,
          id: fila.id_ident_ruta || fila?._ident?.id,
        };

        Swal.fire({
          icon: "success",
          title: "Guardado",
          text: id
            ? `Ruta ${payload.nombre_ruta} actualizada correctamente.`
            : `Ruta ${payload.nombre_ruta} guardada correctamente.`,
          timer: 1500,
          showConfirmButton: false,
        });
      },
      error: (error: any) => {
        fila.guardando = false;
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.error?.message || "No se pudo guardar la ruta identificada.",
        });
      },
    });
  }

  guardarTodoIdentRutas(): void {
    const lista = Array.isArray(this.rutas) ? this.rutas : [];
    if (!lista.length || this.guardandoTodo) {
      return;
    }

    this.guardandoTodo = true;
    const peticiones = lista.map((fila: any) => {
      fila.tipo_ruta = this.normalizarIdSeleccion(fila?.tipo_ruta) || this.obtenerTipoRutaPorDefecto();
      fila.frecuencia_recorrido =
        this.normalizarIdSeleccion(fila?.frecuencia_recorrido) || this.obtenerFrecuenciaPorDefecto();

      const payload = this.construirPayload(fila);
      const id = Number(fila?.id_ident_ruta || 0);
      fila.guardando = true;

      const request$ = id
        ? this.identRutasService.update(id, payload)
        : this.identRutasService.create(payload);

      return request$.pipe(
        map((resp: any) => ({ ok: true, resp, fila, payload })),
        catchError((error) => of({ ok: false, error, fila }))
      );
    });

    forkJoin(peticiones).subscribe({
      next: (resultados: any[]) => {
        const resumen = resultados.reduce(
          (acc: { exitosos: number; errores: number }, item: any) => {
            const fila = item?.fila;
            if (fila) {
              fila.guardando = false;
            }

            if (!item?.ok) {
              acc.errores += 1;
              return acc;
            }

            if (fila && !fila.id_ident_ruta) {
              const idCreado = Number(item?.resp?.id || item?.resp?.ident_ruta?.id || 0);
              if (idCreado) {
                fila.id_ident_ruta = idCreado;
              }
            }

            if (fila) {
              fila._ident = {
                ...(fila?._ident || {}),
                ...item.payload,
                id: fila.id_ident_ruta || fila?._ident?.id,
              };
            }

            acc.exitosos += 1;
            return acc;
          },
          { exitosos: 0, errores: 0 }
        );

        this.guardandoTodo = false;
        const texto = resumen.errores
          ? `Guardados: ${resumen.exitosos} | Errores: ${resumen.errores}`
          : `Guardados: ${resumen.exitosos}`;

        Swal.fire({
          icon: resumen.errores ? "warning" : "success",
          title: resumen.errores ? "Guardado parcial" : "Guardado completado",
          text: texto,
        });
      },
      error: () => {
        lista.forEach((fila: any) => {
          fila.guardando = false;
        });
        this.guardandoTodo = false;
        Swal.fire("Error", "No se pudo completar el guardado masivo.", "error");
      },
    });
  }

  normalizarIdSeleccion(valor: any): number | null {
    const id = Number(valor);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  private construirPayload(fila: any): IdentRutaPayload {
    const tipoRuta = this.normalizarIdSeleccion(fila?.tipo_ruta) || this.obtenerTipoRutaPorDefecto();
    const frecuencia =
      this.normalizarIdSeleccion(fila?.frecuencia_recorrido) || this.obtenerFrecuenciaPorDefecto();

    return {
      nombre_ruta: String(fila?.nombre_ruta || fila?.nombre || "").trim(),
      salida: String(fila?.salida || fila?.municipioOrigen?.MUNICIPIO || fila?.origen || "").trim(),
      destino: String(fila?.destino || fila?.municipioDestino?.MUNICIPIO || "").trim(),
      kilometros_recorridos: this.aNumero(fila?.kilometros_recorridos),
      tipo_ruta: this.aNumero(tipoRuta),
      frecuencia_recorrido: this.aNumero(frecuencia),
      usos_ruta: this.aNumero(fila?.usos_ruta),
      estado: this.aNumero(fila?.estado) || 1,
    };
  }

  private aNumero(valor: any): number {
    const num = Number(valor);
    return Number.isFinite(num) ? num : 0;
  }

  private inicializarFila(ruta: any): any {
    const nombreRuta = String(ruta?.nombre || "").trim();
    const salida = String(ruta?.municipioOrigen?.MUNICIPIO || ruta?.origen || "").trim();
    const destino = String(ruta?.municipioDestino?.MUNICIPIO || ruta?.destino || "").trim();
    const key = this.claveIdentRuta(nombreRuta, salida, destino);
    const guardado = this.registrosIdentRuta[key];

    return {
      ...ruta,
      id_ident_ruta: Number(guardado?.id || 0) || null,
      guardando: false,
      _ident: guardado || null,
      nombre_ruta: guardado?.nombre_ruta || nombreRuta,
      salida: guardado?.salida || salida,
      destino: guardado?.destino || destino,
      kilometros_recorridos: this.aNumero(guardado?.kilometros_recorridos),
      tipo_ruta: this.normalizarIdSeleccion(guardado?.tipo_ruta) || this.obtenerTipoRutaPorDefecto(),
      frecuencia_recorrido:
        this.normalizarIdSeleccion(guardado?.frecuencia_recorrido) ||
        this.obtenerFrecuenciaPorDefecto(),
      usos_ruta: this.aNumero(guardado?.usos_ruta),
      estado: this.aNumero(guardado?.estado) || 1,
    };
  }

  private obtenerTipoRutaPorDefecto(): number {
    const id = Number(this.tiposRuta?.[0]?.id || 0);
    return id || 1;
  }

  private obtenerFrecuenciaPorDefecto(): number {
    const id = Number(this.frecuenciasRecorrido?.[0]?.id || 0);
    return id || 1;
  }

  private normalizarRespuestaIdentRutas(respuesta: any): any[] {
    if (Array.isArray(respuesta)) {
      return respuesta;
    }

    if (Array.isArray(respuesta?.ident_rutas)) {
      return respuesta.ident_rutas;
    }

    if (Array.isArray(respuesta?.data)) {
      return respuesta.data;
    }

    return [];
  }

  private crearIndiceIdentRutas(respuesta: any): Record<string, any> {
    const lista = this.normalizarRespuestaIdentRutas(respuesta);
    const index: Record<string, any> = {};
    lista.forEach((item: any) => {
      const key = this.claveIdentRuta(item?.nombre_ruta, item?.salida, item?.destino);
      if (key) {
        index[key] = item;
      }
    });
    return index;
  }

  private claveIdentRuta(nombreRuta: any, salida: any, destino: any): string {
    const a = String(nombreRuta || "").trim().toUpperCase();
    const b = String(salida || "").trim().toUpperCase();
    const c = String(destino || "").trim().toUpperCase();
    return `${a}|${b}|${c}`;
  }

  private normalizarRespuestaRutas(respuesta: any): Ruta[] {
    if (Array.isArray(respuesta)) {
      return respuesta;
    }

    if (Array.isArray(respuesta?.rutas)) {
      return respuesta.rutas;
    }

    if (Array.isArray(respuesta?.data)) {
      return respuesta.data;
    }

    return [];
  }

  private normalizarOpcionesCatalogo(respuesta: any): Array<{ id: number; descripcion: string }> {
    const lista = Array.isArray(respuesta)
      ? respuesta
      : Array.isArray(respuesta?.data)
      ? respuesta.data
      : Array.isArray(respuesta?.tipo_rutapesv)
      ? respuesta.tipo_rutapesv
      : Array.isArray(respuesta?.frecuencia_recorrido)
      ? respuesta.frecuencia_recorrido
      : Array.isArray(respuesta?.items)
      ? respuesta.items
      : [];

    return lista
      .map((item: any) => ({
        id: Number(item?.id || 0),
        descripcion: String(item?.descripcion || "").trim(),
        estado: Number(item?.estado ?? 1),
      }))
      .filter((item: any) => item.id > 0 && !!item.descripcion && item.estado === 1);
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
}
